import consumer from "./consumer"

document.addEventListener("turbolinks:load", () => {
  const channelName = "RefreshTaskListChannel";
  consumer.subscriptions.create("RefreshTaskListChannel", {
    connected() {
      // Called when the subscription is ready for use on the server
      console.log(`Connected to ${channelName}`);
    },
  
    disconnected() {
      // Called when the subscription has been terminated by the server
      console.log(`Disconnected from ${channelName}`);
  
    },
  
    received(data) {
      // Called when there's incoming data on the websocket for this channel
      let baseUrl = `/${data.account_id}/projects/${data.project_id}/task_lists/${data.task_list_id}/tasks/${data.task_id}/task_blocks/${data.block_id}/ai_referencing_task_blocks`;
      let params = new URLSearchParams({
        progress: data.progress,
        done: data.done,
        ai_text_generator: data.ai_text_generator
      });
      let url = `${baseUrl}?${params.toString()}`;
      let type = 'GET';

      Rails.ajax({
        url: url,
        type: type,
        dataType: "script"
      });
    }
  });
});
